const storageKey = 'portal.asset-reload.v1'
const cooldownMs = 60_000
const assetLoadError = /^(Failed to fetch dynamically imported module:|Importing a module script failed\.|error loading dynamically imported module:|Unable to preload CSS for )/i

export function recoverRouteLoad(error: unknown, path: string): void {
  if (!(error instanceof Error) || !assetLoadError.test(error.message)) return
  const now = Date.now()
  let destination: URL
  try {
    destination = new URL(path, window.location.href)
    if (destination.origin !== window.location.origin) return
    const saved = sessionStorage.getItem(storageKey)
    if (saved !== null && (!Number.isFinite(Number(saved)) || now - Number(saved) < cooldownMs)) return
    const stamp = String(now)
    sessionStorage.setItem(storageKey, stamp)
    if (sessionStorage.getItem(storageKey) !== stamp) return
  } catch {
    return
  }
  if (destination.pathname === window.location.pathname && destination.search === window.location.search) {
    if (destination.hash !== window.location.hash) window.history.replaceState(window.history.state, '', destination.href)
    window.location.reload()
  } else {
    window.location.assign(destination.href)
  }
}
